import { marked } from 'marked';
import { baseUrl } from '../App';
import { useEffect } from 'react';

export default function Banner({ content }) {
    const sisutekst = {__html: marked.parse(content.sisutekst)}
    const bannerImageUrl = baseUrl + content.banneri_pilt.data.attributes.url

    useEffect(() => {
        let hero = document.querySelector(".hero-left")
         if (hero && window.innerWidth < 797) {
            hero.style.backgroundImage = `url(${bannerImageUrl})`
         }
  
        const handleResize = () => {
         if (hero && window.innerWidth < 797) {
            hero.style.backgroundImage = `url(${bannerImageUrl})`
         } else if (hero) {
            hero.style.backgroundImage = ""
         }
        }
        
        window.addEventListener('resize', handleResize);
        
        return () => {
         window.removeEventListener('resize', handleResize);
        };
        
      }, [bannerImageUrl]);

    return (
        <div className="hero">
            <div className="hero-left">
                <div className="hero-text">
                    <div className="heading">
                        <h1 className="hero-heading">{content.pealkiri}</h1>
                    </div>
                    <div className="hero-subheading" dangerouslySetInnerHTML={sisutekst}></div>
                </div>
            </div>
            <div className="hero-right" style={{backgroundImage: `url(${bannerImageUrl})`}}>
            </div>
        </div>
    )
}